import { render, staticRenderFns } from "./actSignPage.vue?vue&type=template&id=2cd87344&scoped=true"
import script from "./actSignPage.vue?vue&type=script&lang=js"
export * from "./actSignPage.vue?vue&type=script&lang=js"
import style0 from "./actSignPage.vue?vue&type=style&index=0&id=2cd87344&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd87344",
  null
  
)

export default component.exports